export const MOBILE_BANNER_WIDTH = 355;
export const TABLET_BANNER_WIDTH = 704;
export const DESKTOP_BANNER_WIDTH = 420;
export const XL_DESKTOP_BANNER_WIDTH = 698;
export const XXL_DESKTOP_BANNER_WIDTH = 842;

export const MOBILE_BANNER_HEIGHT = 264;
export const TABLET_BANNER_HEIGHT = 366;
export const DESKTOP_BANNER_HEIGHT = 591;
export const XL_DESKTOP_BANNER_HEIGHT = 628;